import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { InternationalIcon } from '@arcade/web/icons/react'
import { Flex, Text } from '@cash-design-system/react'
import { FormBlockerElementGiftCardElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { replaceWithCDNImageUrl } from '@cash-web/shared-util-url'

const Card = styled.div<{ url?: string }>`
  background-image: url(${props => props.url});

  /* We expect the images to be the same dimensions as the card, but if they are not then we want to cover the background with the image. */
  background-size: cover;
  background-position: center;
  width: 21rem;
  height: 13.25rem;
  position: relative;
  border-radius: 1.2rem;
  box-shadow: ${props => props.theme.dropShadows.tile};
`

const Amount = styled(Text)`
  position: absolute;
  right: 1.25rem;
  top: 1rem;
`

export const GiftCardElement = (props: FormBlockerElementGiftCardElement) => {
  const { darkMode } = useTheme()

  const url = replaceWithCDNImageUrl({ url: darkMode ? props.card?.dark_url : props.card?.light_url })

  return (
    <Flex flexDirection="column" gap="m" alignItems="center">
      {props.note && (
        <Text typography="labelMedium" color="textStandard">
          {props.note}
        </Text>
      )}
      <Card url={url} role="img" aria-label={props.accessibility_label}>
        {props.amount_text && (
          <Amount typography="sectionTitle" color="constantWhite">
            {props.amount_text}
          </Amount>
        )}
      </Card>
      {props.caption_text && (
        <Flex justifyContent="center" alignItems="center" gap="xs">
          <InternationalIcon size={24} />
          <Text typography="helpText">{props.caption_text}</Text>
        </Flex>
      )}
    </Flex>
  )
}
